(function () {
  var VERSION = "1.0.1";
  var cache = new Map();

  if (window.VidaLabsPdpProof && window.VidaLabsPdpProof.version === VERSION) {
    window.VidaLabsPdpProof.scan();
    return;
  }

  function text(value, fallback) {
    if (value === null || value === undefined) return fallback || "";
    return String(value).trim() || fallback || "";
  }

  function html(value) {
    return text(value).replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[char];
    });
  }

  function field(item, names, fallback) {
    for (var i = 0; i < names.length; i += 1) {
      if (text(item && item[names[i]])) return item[names[i]];
    }
    return fallback || "";
  }

  function safeUrl(value) {
    var url = text(value);
    return /^https?:/i.test(url) ? url : "";
  }

  function slug(value) {
    return text(value)
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function normalizeHandles(value) {
    if (typeof value === "string") value = value.split(",");
    if (!Array.isArray(value)) return [];
    return value.map(slug).filter(Boolean);
  }

  function initials(name) {
    return text(name)
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 3)
      .map(function (part) {
        return part.charAt(0).toUpperCase();
      })
      .join("") || "VL";
  }

  function firstName(person) {
    return text(person.name).split(/\s+/).slice(0, 3).join(" ");
  }

  function normalize(payload) {
    var list = Array.isArray(payload)
      ? payload
      : payload && (payload.profesionales || payload.doctores || payload.items || payload.data);

    if (!Array.isArray(list)) return [];

    return list.map(function (item) {
      return {
        name: text(field(item, ["nombre", "name", "full_name"])),
        specialty: text(field(item, ["especialidad", "specialty", "titulo"], "Profesional de la salud")),
        license: text(field(item, ["cedula", "cedula_profesional", "license"])),
        photo: safeUrl(field(item, ["foto", "photo", "image", "avatar"])),
        handles: normalizeHandles(field(item, ["product_handles", "products", "productos", "handles"], []))
      };
    }).filter(function (person) {
      return person.name;
    });
  }

  function load(source) {
    if (!source) return Promise.resolve([]);
    if (!cache.has(source)) {
      cache.set(source, fetch(source, { credentials: "omit" })
        .then(function (response) {
          if (!response.ok) throw new Error("Professionals JSON unavailable");
          return response.json();
        })
        .then(normalize));
    }
    return cache.get(source);
  }

  function chooseForced(people, forcedSlug, forcedName, forcedLicense) {
    var expectedSlug = slug(forcedSlug || forcedName);
    var expectedLicense = text(forcedLicense);

    if (!expectedSlug && !expectedLicense) return null;

    return people.find(function (person) {
      var personSlug = slug(person.name);
      var matchesSlug = expectedSlug && (
        personSlug === expectedSlug ||
        personSlug.indexOf(expectedSlug) > -1 ||
        expectedSlug.indexOf(personSlug) > -1
      );
      var matchesLicense = expectedLicense && person.license === expectedLicense;
      return matchesSlug || matchesLicense;
    }) || null;
  }

  function choose(people, handle, forcedSlug, forcedName, forcedLicense) {
    var forced = chooseForced(people, forcedSlug, forcedName, forcedLicense);
    if (forced) return forced;

    var current = slug(handle);
    var pool = current
      ? people.filter(function (person) { return person.handles.indexOf(current) > -1; })
      : [];
    if (!pool.length) pool = people;
    if (pool.length === 1) return pool[0];

    var key = "vl-pdp-proof-last-" + (current || "all");
    var last = "";
    try {
      last = window.sessionStorage.getItem(key) || "";
    } catch (error) {}

    var filtered = pool.filter(function (person) {
      return person.name !== last;
    });
    var candidates = filtered.length ? filtered : pool;
    var person = candidates[Math.floor(Math.random() * candidates.length)];

    try {
      window.sessionStorage.setItem(key, person.name);
    } catch (error) {}

    return person;
  }

  function avatar(person) {
    var label = html(person.name);
    if (person.photo) {
      return '<span class="vl-pdp-proof__avatar"><img src="' + html(person.photo) + '" alt="' + label + '" loading="lazy"></span>';
    }
    return '<span class="vl-pdp-proof__avatar"><span>' + html(initials(person.name)) + '</span></span>';
  }

  function render(root, person) {
    var media = root.querySelector("[data-vl-pdp-proof-avatar]");
    var lead = root.querySelector("[data-vl-pdp-proof-lead]");
    var sub = root.querySelector("[data-vl-pdp-proof-sub]");

    if (media) media.innerHTML = avatar(person);
    if (lead) lead.textContent = "Hay un profesional detras de este frasco.";
    if (sub) {
      sub.textContent = firstName(person) + " / " + person.specialty + (person.license ? " / Ced. " + person.license : "");
    }
  }

  function hydrate(root) {
    if (!root || root.dataset.vlPdpProofReady === "true") return;
    root.dataset.vlPdpProofReady = "true";
    root.classList.add("is-loading");

    load(root.dataset.source)
      .then(function (people) {
        if (!people.length) throw new Error("Empty professionals list");
        render(root, choose(
          people,
          root.dataset.productHandle,
          root.dataset.professionalSlug,
          root.dataset.professionalName,
          root.dataset.professionalLicense
        ));
      })
      .catch(function () {
        root.classList.add("is-error");
      })
      .finally(function () {
        root.classList.remove("is-loading");
      });
  }

  function scan() {
    document.querySelectorAll("[data-vl-pdp-proof]").forEach(hydrate);
  }

  window.VidaLabsPdpProof = {
    version: VERSION,
    scan: scan
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
})();
